import { useContext, useEffect, useMemo, useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import UserSchema from "../../../validations/UserSchema";
import cancel from "../../../images/cancel.svg";
import { inputNumber, inputOnlyNumber } from "../../../utils";
import { apiEditUser } from "../../../api/master";
import Select from "react-select";
import Tippy from "@tippyjs/react";
import invoiceIcon from "../../../images/icons/info 1.png";
import $ from "jquery";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { ConfigContext } from "../../../App";

function UserEdit(props) {
  const { brList, godowList, companyListMap } = props;
  const [user, setUser] = useState({});
  console.log("initialState user", user, props.id);
  const accessCode = useContext(ConfigContext)?.accessCode;
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [roleSelect, setRoleSelect] = useState(Number(props.id.role_id));
  const [selectBranch, setSelectBranch] = useState(
    brList.find((b) => b?.value == props.id?.user_branch?.branch_id),
  );
  const [selectGodown, setSelectGodown] = useState(
    godowList.find((b) => b?.value == props.id?.user_godown?.godown_id),
  );

  const roleList = [
    { id: 1, title: "Super Admin", role_id: 0 },
    { id: 2, title: "Admin", role_id: 1 },
    { id: 3, title: "Branch Owner", role_id: 2 },
    { id: 4, title: "Cashier", role_id: 2 },
    { id: 5, title: "Godown Manager", role_id: 2 },
    { id: 7, title: "Associate Cashier", role_id: 2 },
    { id: 8, title: "No Cash Cashier", role_id: 2 },
    { id: 9, title: "Cash Expense Cashier", role_id: 2 },
    { id: 10, title: "Connector", role_id: 2 },
  ];

  const selectedCompany = companyListMap?.find(
    (company) => company.value == props.id?.comp_id,
  );
  console.log("selectedCompanyselectedCompany", selectedCompany);
  const [formikRoleId, setFormikRoleId] = useState(
    props.id?.role_id?.toString() || "",
  );
  // Compute if access_code input should be shown & validated
  const isAccessCodeRequired = useMemo(() => {
    return (
      (user.role_id == 2 && accessCode == 1 && formikRoleId == "3") ||
      (user.role_id == 1 && selectedCompany?.access == 1)
    );
  }, [user.role_id, accessCode, selectedCompany, formikRoleId]);

  const UserFormik = useFormik({
    initialValues: {
      user_id: props.id?.user_id,
      user_name: props.id?.user_name,
      user_mob: props.id?.user_mob,
      pin: props.id?.pin,
      role_id: props.id?.role_id,
      comp_id: props.id?.comp_id,
      branch_id: props.id?.user_branch?.branch_id,
      godown_id: props.id?.user_godown?.godown_id,
      cut_off_days: props.id?.company?.cut_off_days || 0,
      back_date: props.id?.back_date,
      access_code: props.id?.access_code,
      item_level_narration: props.id?.company.item_level_narration,
    },
    validationSchema: UserSchema.validateUserEdit(isAccessCodeRequired),
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: async (values) => {
      let input = {
        user_id: Number(values.user_id),
        user_name: values.user_name,
        user_mob: values.user_mob,
        cut_off_days: values.cut_off_days,
        pin: values.pin,
        role_id: Number(values.role_id),
        comp_id: Number(values.comp_id),
        branch_id: Number(values?.branch_id),
        godown_id: Number(values?.godown_id),
        back_date: values?.back_date,
        access_code: values?.access_code,
        item_level_narration: values?.item_level_narration,
      };
      setIsSubmit(true);
      Object.keys(input).forEach((key) => {
        if (
          input[key] === "" ||
          input[key] === null ||
          input[key] === undefined
        ) {
          delete input[key];
        }
      });
      await apiEditUser(input)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });

  useEffect(() => {
    setRoleSelect(Number(UserFormik?.values?.role_id));
  }, [UserFormik?.values?.role_id]);

  useEffect(() => {
    if (UserFormik.values.role_id !== formikRoleId) {
      setFormikRoleId(UserFormik.values.role_id);
    }
  }, [UserFormik.values.role_id, formikRoleId]);

  const handlePaste = (event) => {
    const pastedText = event.clipboardData.getData("text/plain");
    const onlyNumbers = pastedText.replace(/\D/g, "");
    event.preventDefault();
    document.execCommand("insertText", false, onlyNumbers);
  };

  let lastKey = null;
  function inputNumber(e) {
    let allowKeys = [
      "Tab",
      "Backspace",
      "Delete",
      "Enter",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Control",
    ];

    if (
      (e.ctrlKey || e.metaKey) &&
      ["c", "x", "v", "a"].includes(e.key.toLowerCase())
    ) {
      return true;
    }

    if (!($.isNumeric(e.key) || allowKeys.includes(e.key))) {
      e.preventDefault();
    }

    lastKey = e.key;
  }
  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
          Edit User
        </h4>
      </Modal.Header>

      <div className="container-fluid p-4" id="userAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={UserFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="user_name">
              User Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="user_name"
              {...UserFormik.getFieldProps("user_name")}
            />
            {UserFormik.errors.user_name ? (
              <div className="text-danger small">
                {UserFormik.errors.user_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="user_mob">
              Mobile No <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onKeyDown={inputNumber}
              onPaste={handlePaste}
              className="form-control"
              id="user_mob"
              disabled={props?.id?.role_id == 2}
              {...UserFormik.getFieldProps("user_mob")}
              // disabled
            />
            {UserFormik.errors.user_mob ? (
              <div className="text-danger small">
                {UserFormik.errors.user_mob}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="pin">
              PIN <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              onKeyDown={inputNumber}
              className="form-control"
              id="pin"
              {...UserFormik.getFieldProps("pin")}
              maxLength={4}
              // disabled
            />
            {UserFormik.errors.pin ? (
              <div className="text-danger small">{UserFormik.errors.pin}</div>
            ) : null}
          </div>
          {props.id.role_id === 2 ? (
            <div className="col-md-6">
              <label htmlFor="role_id">
                User Role <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                // onKeyDown={}
                className="form-control"
                id="role_id"
                value={"Admin"}
                disabled
              />
            </div>
          ) : (
            <div className="col-md-6">
              <label htmlFor="role_id">
                User Role <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="role_id"
                {...UserFormik.getFieldProps("role_id")}
                disabled={props?.id?.role_id == 2}
              >
                <option value="" hidden>
                  Select...
                </option>

                {roleList.map((list) => {
                  if (user?.role_id === list.role_id) {
                    return <option value={list.id}>{list.title}</option>;
                  }
                })}
              </select>
              {UserFormik.errors.role_id ? (
                <div className="text-danger small">
                  {UserFormik.errors.role_id}
                </div>
              ) : null}
            </div>
          )}

          {user.role_id === 1 ? (
            <div className="col-md-6">
              <label htmlFor="comp_id">
                Company Name
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="comp_id"
                {...UserFormik.getFieldProps("comp_id")}
                disabled={props?.id?.role_id == 2}
              >
                <option value="" hidden>
                  Select...
                </option>
                {companyListMap
                  .filter((list) => list.is_active)
                  .map((list) => {
                    return <option value={list.value}>{list.label}</option>;
                  })}
              </select>
              {UserFormik.errors.comp_id ? (
                <div className="text-danger small">
                  {UserFormik.errors.comp_id}
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}
          {isAccessCodeRequired && (
            <div className="col-md-6">
              <label htmlFor="access_code">
                Access Code <span className="text-danger">*</span>
              </label>
              <input
                maxLength={4}
                type="text"
                onKeyDown={inputNumber}
                className="form-control"
                id="access_code"
                {...UserFormik.getFieldProps("access_code")}
              />
              {UserFormik.errors.access_code ? (
                <div className="text-danger small">
                  {UserFormik.errors.access_code}
                </div>
              ) : null}
            </div>
          )}

          {user.role_id === 2 &&
          (roleSelect == 3 ||
            roleSelect == 4 ||
            roleSelect == 5 ||
            roleSelect == 8 ||
            roleSelect == 9 ||
            roleSelect == 7) ? (
            <div className="col-md-6">
              <label htmlFor="branch_id">
                Branch list
                <span className="text-danger">*</span>
              </label>
              <Select
                options={brList}
                value={selectBranch}
                isDisabled={props?.id?.role_id == 2}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    minHeight: "0px",
                  }),
                  valueContainer: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  input: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                  }),
                  dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                }}
                classNamePrefix="react-select"
                tabSelectsValue
                onChange={(selectedOption) => {
                  setSelectBranch(selectedOption);
                  UserFormik.setFieldValue("branch_id", selectedOption.value);
                  UserFormik.setFieldValue("godown_id", "");
                  setSelectGodown("");
                }}
                name="branch_id"
              />
              {UserFormik.errors.branch_id ? (
                <div className="text-danger small">
                  {UserFormik.errors.branch_id}
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}

          {user.role_id === 2 && roleSelect == 5 ? (
            <div className="col-md-6">
              <label htmlFor="godown_id">
                Godown list
                <span className="text-danger">*</span>
              </label>
              <Select
                options={godowList.filter((f) =>
                  f.branch_id?.includes(UserFormik.values.branch_id),
                )}
                isDisabled={props?.id?.role_id == 2}
                value={selectGodown}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    minHeight: "0px",
                  }),
                  valueContainer: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  input: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                  }),
                  dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                }}
                classNamePrefix="react-select"
                tabSelectsValue
                onChange={(selectedOption) => {
                  setSelectGodown(selectedOption);
                  UserFormik.setFieldValue("godown_id", selectedOption.value);
                }}
                name="godown_id"
              />
              {UserFormik.errors.godown_id ? (
                <div className="text-danger small">
                  {UserFormik.errors.godown_id}
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}

          {user.role_id != 1 && props.id.role_id == 2 && (
            <div className="col-md-6">
              <label htmlFor="cut_off_days">
                Cut off days{" "}
                <Tippy
                  placement="top"
                  content={`Cut Off: Set data visibility up to 90 days. '0' means all data visible. User can see latest ${UserFormik?.values?.cut_off_days} days data.`}
                >
                  <img
                    src={invoiceIcon}
                    className="img-fluid me-3"
                    alt=""
                    role="button"
                    style={{
                      width: "16px",
                      height: "16px",
                      alignItems: "center",
                      marginLeft: "10px",
                      marginBottom: "6px",
                    }}
                  />
                </Tippy>
              </label>
              <input
                type="text"
                // onKeyDown={}
                className="form-control"
                id="cut_off_days"
                // {...UserFormik.getFieldProps("cut_off_days")}
                value={UserFormik.values.cut_off_days}
                onKeyDown={inputNumber}
                maxLength={2}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (value < 0 || value > 90) {
                    UserFormik.setFieldValue("cut_off_days", "");
                  } else {
                    UserFormik.setFieldValue("cut_off_days", e.target.value);
                  }
                }}
                // disabled
              />
              {UserFormik.errors.cut_off_days ? (
                <div className="text-danger small">
                  {UserFormik.errors.cut_off_days}
                </div>
              ) : null}
            </div>
          )}
          {user.role_id != 1 && props.id.role_id == 2 && (
            <div className="col-md-6">
              <label htmlFor="comp_id">
                Item Narration <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="item_level_narration"
                {...UserFormik.getFieldProps("item_level_narration")}
              >
                <option value="" hidden>
                  Select...
                </option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
              {UserFormik.errors.item_level_narration ? (
                <div className="text-danger small">
                  {UserFormik.errors.item_level_narration}
                </div>
              ) : null}
            </div>
          )}
          <div className="col-md-6">
            <label htmlFor="back_date">
              Back Days <span className="text-danger">*</span>
            </label>

            <InputGroup className="">
              <Form.Control
                icon={"Days"}
                maxLength={3}
                type="text"
                inputStyle={{ height: "34px" }}
                // onKeyDown={(e) => {
                //   setTimeout(() => {
                //     const value = parseInt(e.target.value, 10);
                //     if (value < 0 || value > 365) {
                //       e.target.value = "";
                //     }
                //   }, 0);

                //   inputNumber(e);
                // }}
                onChange={(e) => {
                  let value = e.target.value;

                  // Allow only numbers
                  if (!/^\d*$/.test(value)) {
                    return;
                  }

                  // Convert to number for range validation
                  const numericValue = parseInt(value, 10);

                  // If within range, update formik
                  if (
                    value === "" ||
                    (numericValue >= 0 && numericValue <= 365)
                  ) {
                    UserFormik.setFieldValue("back_date", value);
                  } else {
                    UserFormik.setFieldValue("back_date", "");
                  }
                }}
                className="form-control"
                style={{
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
                id="back_date"
                value={UserFormik.values?.back_date}
                // {...UserFormik.getFieldProps("back_date")}
              />
              <InputGroup.Text id="basic-addon2">Days</InputGroup.Text>
            </InputGroup>
            {UserFormik.errors.back_date ? (
              <div className="text-danger small">
                {UserFormik.errors.back_date}
              </div>
            ) : null}
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                float: "right",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                src={cancel}
                type="button"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmit}
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                {isSubmit && (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                )}
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default UserEdit;
